import { Controller } from "@hotwired/stimulus"

// Right-edge dot navigation for pages with many text sections.
// Each dot links to a section's #anchor; the dot for the section
// currently under a thin band near the top of the viewport (just
// below the sticky header) is highlighted. Using a top-anchored band
// instead of a centered one means the first section is already
// "intersecting" at scroll position 0, so a dot is active immediately
// on load instead of only after the user starts scrolling.
export default class extends Controller {
  static targets = ["dot"]

  connect() {
    this.sections = this.dotTargets
      .map(dot => document.getElementById(dot.dataset.anchor))
      .filter(Boolean)

    const headerHeight = document.querySelector("header")?.offsetHeight || 70

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: `-${headerHeight}px 0px -70% 0px`,
      threshold: 0
    })
    this.sections.forEach(section => this.observer.observe(section))

    this.dotTargets.forEach(dot => {
      dot.addEventListener("click", this.onClick.bind(this))
    })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  onIntersect(entries) {
    entries.forEach(entry => {
      const dot = this.dotTargets.find(d => d.dataset.anchor === entry.target.id)
      if (dot) dot.classList.toggle("is-active", entry.isIntersecting)
    })
  }

  onClick(event) {
    event.preventDefault()
    const anchor = event.currentTarget.dataset.anchor
    const target = document.getElementById(anchor)
    if (!target) return
    const navHeight = document.querySelector("header")?.offsetHeight || 70
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - navHeight,
      behavior: "smooth"
    })
  }
}
